import React from "react"
import CurrentBusinessHour from "./CurrentBusinessHour"
import Lamp from "./Summary/Lamp"
import { addressOrDistance } from "../../Utils/place_helper"

import * as styles from "./Styles/Summary.module.scss"
import "../../../styles/layouts"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

import { Place } from "../../types/place"
interface SummaryProps {
  place: Place
}

const Summary: React.FC<SummaryProps> = (props) => {
  return (
    <a href={props.place.path}>
      <div className="l-flex l-flex-space-between">
        <div className={cn("left", props.place.image ? "withImage" : "")}>
          <div className={styles.annotation}>
            {addressOrDistance(props.place.address, props.place.distance)}
          </div>
          <div className={styles.name}>{props.place.name}</div>
          <div className={styles.annotation}>
            <React.Fragment>
              <CurrentBusinessHour place={props.place} />
            </React.Fragment>
          </div>
          <Lamp lamp={props.place.crowdLamp} />
        </div>
        <div className={styles.right}>
          {props.place.image && <img src={props.place.image} />}
        </div>
      </div>
    </a>
  )
}
export default Summary
